import React, { useEffect, useState } from "react";

// Effet "Blur Text" (façon reactbits.dev), réécrit en interne pour rester sans dépendance externe :
// le texte apparaît mot par mot en sortant du flou, plutôt que d'apparaître d'un bloc. Purement
// une animation d'entrée — aucune couleur ajoutée, hérite du style du texte englobant (voir
// Login.tsx, l'accroche "YOU WILL NEVER BE ALONE").
//
// delay : délai avant le premier mot (ms). stagger : écart entre deux mots (ms).
export default function BlurText({
  text,
  delay = 0,
  stagger = 60,
  style,
}: {
  text: string;
  delay?: number;
  stagger?: number;
  style?: React.CSSProperties;
}) {
  const words = text.split(" ");
  // Un seul état "monté" plutôt qu'un état par mot : chaque mot lit simplement sa propre
  // transition-delay CSS, pas besoin de re-render par mot.
  const [started, setStarted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setStarted(true), 20); // laisse le temps au premier paint (état flou) avant de déclencher la transition
    return () => clearTimeout(timer);
  }, []);

  return (
    <span style={{ ...style, display: "inline-flex", flexWrap: "wrap", justifyContent: "inherit", rowGap: "0.2em" }}>
      {words.map((word, i) => (
        <span
          key={i}
          style={{
            display: "inline-block",
            marginRight: "0.28em",
            filter: started ? "blur(0px)" : "blur(8px)",
            opacity: started ? 1 : 0,
            transform: started ? "translateY(0)" : "translateY(6px)",
            transition: `filter 0.6s ease, opacity 0.6s ease, transform 0.6s ease`,
            transitionDelay: `${delay + i * stagger}ms`,
          }}
        >
          {word}
        </span>
      ))}
    </span>
  );
}
